import { css, cx } from 'emotion';

import {
	lightGrey,
	headingLarge,
	headingMediumLight,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	textBlockRichFormat,
	textBlock,
	detailSideBarLayout,
} from 'inside-out/global-styles';

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	position: 'relative',
});

export const bodyStyle = cx(
	textBlockRichFormat,
	css({
		h1: cx(
			headingLarge,
			css({
				margin: '0 0 36px 0',
			})
		),
	})
);

export const ctaStyle = css({
	marginTop: '60px',
	'& > *': {
		marginTop: '30px',
	},
});

export const thumbnailStyle = css({
	border: `1px solid ${lightGrey}`,
	borderRadius: '6px',
	marginBottom: '20px',

	'& img': {
		width: '100%',
		maxWidth: '100%',
	},

	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		display: 'none',
	},
});

export const titleStyle = cx(
	headingLarge,
	css({
		maxWidth: '800px',
		margin: '0 0 24px 0',
		color: '#fff',
	})
);

export const subTitleStyle = cx(
	headingMediumLight,
	css({
		paddingBottom: '15px',
	})
);

export const metaAudiencesStyle = css({
	'& svg:not(:last-child)': {
		marginRight: '6px',
	},
	zIndex: '2',
	marginBottom: '11px',
});

export const bookmarkButtonStyle = css({
	background: 'none',
	border: 'none',
	padding: 0,
	display: 'inline-block',
	marginBottom: '35px',
});

export const mobileShareStyle = css({
	display: 'none',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		position: 'fixed',
		left: '0',
		bottom: '0',
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '5px 10px',
		background: '#F6F6F6',
		borderTop: `1px solid ${lightGrey}`,
	},
});

export const detailWrapperStyle = cx(
	detailSideBarLayout.wrapper,
	css({
		paddingBottom: '80px',
	})
);

export const bookmarkMobileButtonStyle = css({
	border: 'none',
	padding: '0',
});

export const metaBottomStyle = css({
	'& span': cx(
		textBlock,
		css({
			color: '#fff',
			[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
				fontSize: '12px',
			},
			'&:not(:last-child)': {
				marginRight: '40px',
				position: 'relative',
				'&:after': {
					content: "'•'",
					display: 'block',
					position: 'absolute',
					transform: 'translate(-50%, -50%)',
					left: 'calc(100% + 20px)',
					top: '50%',
				},
			},
		})
	),
});

export const pageHeaderStyle = background =>
	css({
		minHeight: '270px',
		background: `transparent url(${background}) no-repeat center center`,
		backgroundSize: 'cover',
		position: 'relative',
		display: 'flex',
		alignItems: 'center',

		'&:after': {
			position: 'absolute',
			top: '0',
			left: '0',
			opacity: '0.6',
			width: '100%',
			height: '100%',
			display: 'block',
			content: '" "',
			background: '#000',
			borderRadius: '6px',
		},
	});

export const pageHeaderInnerWrapperStyle = cx(
	innerWrapperStyle,
	css({
		position: 'relative',
		zIndex: '1',
		padding: '0 37px',
	})
);



// WEBPACK FOOTER //
// ./src/page-styles/blog-and-podcast/detail/index.js